"use strict";

exports.__esModule = true;
exports.GetContainerMixin = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _overlay = require("./popup/overlay");
var GetContainerMixin = {
  props: {
    // return the mount node for popup
    getContainer: [String, Function]
  },
  data: function data() {
    return {
      moved: false
    };
  },
  watch: {
    getContainer: function getContainer() {
      this.move();
    }
  },
  mounted: function mounted() {
    if (this.getContainer) {
      this.move();
    }
    this.moved = true;
  },
  activated: function activated() {
    if (this.getContainer) {
      this.move();
    }
    this.moved = true;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.getContainer) {
      this.moveBack();
    }
    this.moved = false;
  },
  deactivated: function deactivated() {
    if (this.getContainer) {
      this.moveBack();
    }
    this.moved = false;
  },
  methods: {
    move: function move() {
      var container;
      var getContainer = this.getContainer;
      if (getContainer) {
        container = typeof getContainer === 'string' ? document.querySelector(getContainer) : getContainer();
      } else if (this.$parent) {
        container = this.$parent.$el;
      }
      if (container && container.nodeType === 1 && container !== this.$el.parentNode) {
        container.appendChild(this.$refs.getContainerElm || this.$el);
      }
      if (this.overlay) {
        (0, _overlay.updateOverlay)();
      }
    },
    moveBack: function moveBack() {
      try {
        if (this.$parent && this.$parent.$el && this.$parent.$el.toString().includes('Element')) {
          this.$parent.$el.appendChild(this.$refs.getContainerElm || this.$el);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
exports.GetContainerMixin = GetContainerMixin;